import { motion } from 'motion/react'
import { ReactElement } from 'react'

export const LivePortraitAnimation = (props: { children?: ReactElement }) => (
  <motion.div
    animate={{
      translateX: [-40, 40, -40],
      rotate: [0, 90, 0],
    }}
    transition={{
      repeat: Infinity,
      repeatType: 'loop',
      duration: 2,
    }}
  >
    {props.children}
  </motion.div>
)

export const SingingPortraitAnimation = (props: { children?: ReactElement }) => (
  <motion.div
    animate={{
      scale: [1, 1.2, 1.2, 1],
    }}
    transition={{
      repeat: Infinity,
      repeatType: 'loop',
      duration: 0.7,
    }}
  >
    {props.children}
  </motion.div>
)
